###
  Objects JSON validator
###

class INTENT.widgets.JsonValidator

  @ATTR_NAME: "data-widget-json-validator"

  constructor: (@el) ->
    @s = @.constructor

    @el.on 'click', (e) =>
      e.preventDefault()

      self = $(e.target)
      object_code = self.data('json-validator-object-code')
      object_id = self.data('json-validator-object-id')
      object_advertiser_id = self.data('json-validator-object-advertiser-id')
      object_creative_type = self.data('json-validator-object-creative-type')

      self.showLoader()

      if target_raw = self.data('json-validator-target-raw')
        target_raw = $(target_raw).eq(0)
        if codemirror = target_raw.data('CodeMirrorInstance')
          object_json = codemirror.getValue()
          @validate_json(object_code, object_json, @el)

      else if target_form = self.data('json-validator-target-form')
        target_form = $(target_form).eq(0)
        object_array = target_form.serializeObject()
        if object_id
          object_array['id'] = object_id
        if object_advertiser_id
          object_array['advertiser_id'] = object_advertiser_id
        if object_creative_type or object_code == 'action_rules'
          if object_code != 'action_rules'
            object_array['creative_type'] = object_creative_type
          if codemirror_instances
            for cm_key of codemirror_instances
              codemirror_instances[cm_key].save()
          form_data = $(self).parents('form').serializeObject()
          @delete_empty_properties(form_data, true)
          for own key, value of form_data
            if(value)
              object_array[key] = value
        @validate_json(object_code, object_array, @el)

  show_alert: (alert_type, alert_message) =>
    options = {}
    if 'danger' == alert_type
      options.auto_hide = no
    INTENT.utils.Notify.message alert_message, alert_type, options

  validate_json: (object_code, object_data, button) =>
    ajax_data = {
      'object_code': object_code
    }
    if typeof object_data == 'string'
      ajax_data['object_json'] = object_data
    else
      ajax_data['object_array'] = object_data

    $.ajax({
      url: '/ajax/validate_json/',
      dataType: 'json',
      method: 'post',
      data: ajax_data,
      beforeSend: =>
        button.addClass 'disabled'
      complete: =>
        button.removeClass 'disabled'
        button.hideLoader();
      success: (data) =>
        if data.success
          @show_alert 'success', __('json.validation.ok')
        else
          @show_alert 'danger', data.error
      error: (jqXHR, textStatus, errorThrown) =>
        # console.error 'ajax error', errorThrown, jqXHR
    })

  delete_empty_properties: (object, recurse) =>
    for own key, value of object
      if Array.isArray value
        object[key] = value.filter (item) ->
          return item != undefined
        @delete_empty_properties(value, recurse)
    return object;
